window._mode='front';window._protocol='https://';window._domain='www.votre-etiquette.com';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/ve/';window._api='/api/v2/';
import CSRFToken from 'components/csrf.js';
import getJSVars from 'components/jsvars.js';
import Translations from 'components/translations.js';
import Recaptcha from 'components/recaptcha.js';
import Swiper from 'theme/swiper/swiper.min.mjs';
import setModelPreview from 'theme/model_preview.js';
import { Adjust_last_star } from 'theme/review_stars.js';
import { EffectFlip, Navigation, Pagination, Grid, Autoplay  } from 'theme/swiper/modules/index.min.mjs';
import { widget_search, setLogoWindowSize, setIconMenu, MenuInit, setCollapseMenuFooter, setFooterSocial, setReviewsStar } from 'theme/interface.js';
import Favorites from 'theme/favorites.js';
import Gsi from 'theme/gsi.js';
import Tracking from 'theme/tracking.js';
import Axeptio from 'theme/axeptio.js';
import Notice from 'components/notice.js';
import animateCSS from 'theme/animatecss.js';


export default async function init()
{
    CSRFToken();
	getJSVars();
	await Translations.init();
	Recaptcha();

    // Tracking
    window.tracking_event = 'landing_page';
	Tracking();

    // Instanciation des notices
    const _notice = new Notice();
    // Affecte la class notice partout sur window
    window._Notice = _notice;

    // ICONE FAVORIS DES MODELES
    Favorites();


	// Change de logo en fonction de la taille de l'écran
	window.addEventListener('resize', () =>
	{
		setLogoWindowSize();

        setReflexionSize();

        setCollapseMenuFooter();

        setFooterSocial();
	});
	setLogoWindowSize();
    setCollapseMenuFooter();
    setFooterSocial();

    Adjust_last_star();

    setModelPreview();


	// Widget Search
    widget_search();
	

	// ICON DU MENU
	setIconMenu();

    // ICON AVIS FOOTER
	setReviewsStar();


	// APPEAR ON SCROLL
	if(typeof WOW !== 'undefined')
	{
		new WOW({
			animateClass: 'animate__animated lazy',
		}).init();
	}

    // SWIPER CATEGORIES
    new Swiper('.carousel-home-categories', {
        modules: [Navigation, Pagination, Grid],
        slidesPerView: 2,
        spaceBetween: 10,
        createElements: true,
        autoHeight: false,
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            enabled: true
        },
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 6,
                spaceBetween: 20
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 8,
                spaceBetween: 20
            }
        }
	});


    // SWIPER NOUVEAUX MODELES
    new Swiper('.carousel-home-new-models', {
        modules: [Navigation, Pagination, Grid],
        slidesPerView: 2,
        spaceBetween: 10,
        createElements: true,
        autoHeight: false,
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            enabled: true
        },
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 5,
                spaceBetween: 20
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 6,
                spaceBetween: 20
            }
        }
	});


    // SWIPER MARKETING EVENTS
    new Swiper('.carousel-home-marketings-events', {
        modules: [Navigation, Pagination, Grid],
        slidesPerView: 2,
        spaceBetween: 10,
        createElements: true,
        autoHeight: false,
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            enabled: true
        },
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 5,
                spaceBetween: 20
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 6,
                spaceBetween: 20
            }
        }
	});


    // SWIPER BEST SELLERS
    new Swiper('.ve-best-sellers-swiper', {
        modules: [EffectFlip, Pagination, Autoplay],
        effect: "flip",
        grabCursor: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className)
            {
                return `<svg width="352" height="50" class="mt-1 ve-icon ve-sm ${className}" id="ve-logo-custengine"><use href="/web/_themes/ve/img/sprite.svg?t=20250522f#ve4-radio-checked"></use></svg>`;
            },
        },
        on: {
            transitionStart: function (swiper)
            {
                setReflexionSize();
            },
            slideChange: function (swiper)
            {
                let toHide = swiper.slides[swiper.previousIndex].getAttribute('data-id');
                let toShow = swiper.slides[swiper.activeIndex].getAttribute('data-id');

                if (toShow && toHide)
                {
                    animateCSS(document.getElementById(`ve-best-seller-${toHide}`), 'fadeOut').then(() =>
                    {
                        document.getElementById(`ve-best-seller-${toHide}`).classList.add('d-none');
                        document.getElementById(`ve-best-seller-${toShow}`).classList.remove('d-none');
                        animateCSS(document.getElementById(`ve-best-seller-${toShow}`), 'fadeIn');
                    });
                }
            }
        }
    });

    // SWIPER HASHTAG
    new Swiper('.carousel-home-hashtag', {
        modules: [Navigation, Pagination, Grid],
        slidesPerView: 2,
        spaceBetween: 0,
        createElements: true,
        autoHeight: false,
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            enabled: true
        },
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 4,
                spaceBetween: 0
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 6,
                spaceBetween: 0
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 8,
                spaceBetween: 0
            }
        }
	});

	document.querySelectorAll('.ctz-model-thumb').forEach((image, index) => {
		image.addEventListener('click', () => {
			swiper.slideTo(index);
		});
	});

	

	// Menu
	MenuInit();

    // Popup Google se connecter
    Gsi();


    // Axeptio
  	Axeptio()
}



function setReflexionSize()
{
    const reflex = document.querySelector('.ve-best-sellers-swiper .swiper-slide-active .ve-3d-slide-mirror');
    const widthCurrent = parseFloat(window.getComputedStyle(document.querySelector('.ve-best-sellers-swiper .swiper-slide-active .ve-3d-slide')).width);
    const widthOrigin = parseFloat(document.querySelector('.ve-best-sellers-swiper .swiper-slide-active .ve-3d-slide').getAttribute('data-width'));
    const widthReflexion = parseFloat(reflex.naturalWidth);
    const coef = widthCurrent / widthOrigin;

    if (widthCurrent != widthOrigin)
    {
        reflex.style.width = widthReflexion * coef + 'px';
    }
}





/* ATTENTION : ici on init le module car dans le process normal (sans spécifier de JS à la page) le init est appelé par le JS du controleur ! */
init();